import Vue from 'vue';

export default {
    allVpcSet: {},
    AvailableIpAddress: {},
    NotAvailableIpAddress: {},
    SubnetSet: {},
    adrListSet: {}
}